<template>
  <payment-method-layout
    :value="value"
    :active="active"
    :logo-src="paymentMethodInfo.logoSrc"
    :show-inactive-chip="showControls"
    :show-delete="!active && showControls"
    @method:delete="emit('method:delete')"
    @method:set-default="emit('method:set-default')"
  >
    {{ cardInfo.number }}
    <template #subtitle>
      Exp.: {{ cardInfo.exp }}
    </template>
  </payment-method-layout>
</template>

<script setup lang="ts">
import { PaymentMethodInfo } from '@/services/billing-utils';
import { PropType, computed } from 'vue';
import PaymentMethodLayout from './PaymentMethodLayout.vue';

const emit = defineEmits(['method:delete', 'method:set-default']);

const props = defineProps({
  value: { type: String as PropType<string>, required: true },
  active: { type: Boolean as PropType<boolean>, default: false },
  paymentMethodInfo: { type: Object as PropType<PaymentMethodInfo>, required: true },
  showControls: { type: Boolean, required: false, default: false },
});

const cardInfo = computed(() => props.paymentMethodInfo.cardInfo);

</script>
